import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-approve-accept',
  templateUrl: './modal-approve-accept.component.html',
  styleUrls: ['./modal-approve-accept.component.css']
})
export class ModalApproveAcceptComponent  {

  constructor(public dialogRef: MatDialogRef<ModalApproveAcceptComponent>) { }

  closeModalAccept(){
    this.dialogRef.close(true);
  }

}
